import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@cgn/framework-ui-components/v2';

const FooterCompilaQuesito = ({
  onIndietroClick, onAvantiClick, oggetto, messaggio,
}) => (
  <>
    <Button
      emphasis={Button.Emphasis.HIGH}
      onClick={onIndietroClick}
    >
      Indietro
    </Button>
    <Button
      disabled={!oggetto || !messaggio}
      emphasis={Button.Emphasis.HIGH}
      onClick={onAvantiClick}
      primary
    >
      Invia quesito
    </Button>
  </>
);

FooterCompilaQuesito.propTypes = {
  onIndietroClick: PropTypes.func.isRequired,
  onAvantiClick: PropTypes.func.isRequired,
  servizio: PropTypes.shape({
    IdServizio: PropTypes.number,
  }).isRequired,
  categoria: PropTypes.shape({
    IdCategoria: PropTypes.number,
    IdCategoriaPadre: PropTypes.number,
    InfoEvasione: PropTypes.string,
    EsclusivaEccellenza: PropTypes.bool,
    argomenti: PropTypes.arrayOf({
      IdCategoria: PropTypes.number,
      IdCategoriaPadre: PropTypes.number,
    }),
  }).isRequired,
  argomento: PropTypes.shape({
    IdCategoria: PropTypes.number.isRequired,
    Categoria: PropTypes.string.isRequired,
    EtichettaCampoAux1: PropTypes.string,
    EtichettaCampoAux2: PropTypes.string,
  }),
  oggetto: PropTypes.string,
  messaggio: PropTypes.string,
};

FooterCompilaQuesito.defaultProps = {
  argomento: undefined,
  oggetto: undefined,
  messaggio: undefined,
};

export default FooterCompilaQuesito;
